import BlNavbarSubtitleMv from './BlNavbarSubtitleMv.vue'

BlNavbarSubtitleMv.install = function(Vue) {
  Vue.component(BlNavbarSubtitleMv.name, BlNavbarSubtitleMv)
}

export default BlNavbarSubtitleMv
